import gen from "@/functions/general.js"

export const SUGGESTION_KEYS = [
  "Measures",
  "CranialNerves1",
  "NeuroPeriph",
  "MotorCoordination",
  "Head",
  "Ent",
  "Thorax",
  "Abdomen",
  "ShoulderL",
  "ShoulderR",
  "EllbowL",
  "EllbowR",
  "UpperArmL",
  "UpperArmR",
  "ForeArmL",
  "ForeArmR",
  "WristL",
  "WristR",
  "HandL",
  "HandR",
  "HipL",
  "HipR",
  "ThighL",
  "ThighR",
  "KneeL",
  "KneeR",
  "LowerLegL",
  "LowerLegR",
  "AnkleL",
  "AnkleR",
  "FootL",
  "FootR",
  "Lymph",
]

const LATERALITY_KEYS = [
  "Shoulder",
  "Ellbow",
  "UpperArm",
  "ForeArm",
  "Wrist",
  "Hand",
  "Hip",
  "Thigh",
  "Knee",
  "LowerLeg",
  "Ankle",
  "Foot",
]

const OPPOSITES_FR = [
  ["positif", "négatif"],
  ["positive", "négative"],
  ["positifs", "négatifs"],
  ["positives", "négatives"],
  ["présent", "absent"],
  ["présente", "absente"],
  ["présents", "absents"],
  ["présentes", "absentes"],
  ["normal", "anormal"],
  ["normale", "anormale"],
  ["normaux", "anormaux"],
  ["normales", "anormales"],
  ["présence", "absence"],
  //Has to come AFTER normal
  ["diminué", "normal"],
  ["diminuée", "normale"],
  ["diminués", "normaux"],
  ["diminuées", "normales"],
  ["augmenté", "normal"],
  ["augmentée", "normale"],
  ["augmentés", "normaux"],
  ["augmentées", "normales"],
]

const OPPOSITES_DE = [
  ["positiv", "negativ"],
  ["positive", "negative"],
  ["anwesend", "abwesend"],
  ["anwesende", "abwesende"],
  ["normal", "anormal"],
  ["normale", "anormale"],
  ["Anwesenheit", "Abwesenheit"],
  ["vermindert", "normal"],
  ["verminderte", "normale"],
  ["erhöht", "normal"],
  ["erhöhte", "normale"],
]

const OPPOSITES_EN = [
  ["positive", "negative"],
  ["present", "absent"],
  ["normal", "abnormal"],
  ["presence", "absence"],
  ["decreased", "normal"],
  ["increased", "normal"],
]

const OPPOSITES_ES = [
  ["positivo", "negativo"],
  ["positiva", "negativa"],
  ["positivos", "negativos"],
  ["positivas", "negativas"],
  ["presente", "ausente"],
  ["presentes", "ausentes"],
  ["normal", "anormal"],
  ["normales", "anormales"],
  ["presencia", "ausencia"],
  ["disminuido", "normal"],
  ["disminuida", "normal"],
  ["disminuidos", "normales"],
  ["disminuidas", "normales"],
  ["aumentado", "normal"],
  ["aumentada", "normal"],
  ["aumentados", "normales"],
  ["aumentadas", "normales"],
]

export const LATERALITY_KEYS_FULL = LATERALITY_KEYS.flatMap(item => [
  item + "R",
  item + "L"
])

function getNegationTerm(str, sctLanguage) {
  let negationPrefix
  let currOpposites
  if (['FrFr'].includes(sctLanguage)) {
    negationPrefix = "Pas de "
    currOpposites = OPPOSITES_FR
  } else if (['EnUs', 'EnGb'].includes(sctLanguage)) {
    negationPrefix = "No "
    currOpposites = OPPOSITES_EN
  } else if (['DeDe'].includes(sctLanguage)) {
    negationPrefix = "Kein(e) "
    currOpposites = OPPOSITES_DE
  } else if (['EsEs'].includes(sctLanguage)) {
    negationPrefix = "No "
    currOpposites = OPPOSITES_ES
  } else {
    negationPrefix = "No "
    currOpposites = OPPOSITES_FR
  }  
  let normalizedStr = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  let replacedBol = false
  currOpposites.forEach(pair => {
    if (replacedBol) return;
    const [term1, term2] = pair
    const normalizedTerm1 = term1.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const normalizedTerm2 = term2.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    const regex = new RegExp(`\\b(${normalizedTerm1}|${normalizedTerm2})\\b`, 'gi')
    normalizedStr = normalizedStr.replace(regex, (matched) => {
      if (matched.toLowerCase() === normalizedTerm1.toLowerCase()) {
        replacedBol = true
        return matchCase(matched, term2)
      } else {
        replacedBol = true
        return matchCase(matched, term1)
      }
    })
  })
  return (replacedBol)
    ? normalizedStr
    : negationPrefix + str.charAt(0).toLowerCase() + str.slice(1);
}

function matchCase(matched, replacement) {
  if (matched === matched.toUpperCase()) {
      return replacement.toUpperCase()
  } else if (matched === matched[0].toUpperCase() + matched.slice(1).toLowerCase()) {
      return replacement[0].toUpperCase() + replacement.slice(1).toLowerCase()
  } else {
      return replacement.toLowerCase()
  }
}


function parseResultSuggestion(suggestionString, sctLanguage) {
  let entry = suggestionString.trim()
  const underscoreIndex = entry.lastIndexOf("_")
  const unit = (underscoreIndex > -1)
    ? entry.substring(underscoreIndex + 1).trim()
    : ""
  entry = (underscoreIndex > -1)
    ? entry.substring(0, underscoreIndex).trim()
    : entry
  const neg = (!unit && underscoreIndex === -1)
    ? getNegationTerm(entry, sctLanguage)
    : ""
  //Return
  return {
    "unit" : unit,
    "entry" : entry,
    "neg" : neg,
  }
}

export function createReferenceSheetTitle(refSheet) {
  const triggerText = refSheet.triggers
  const lines = triggerText.split('\n')
  return lines[0]
}

export function createResultSuggestionsFromText (suggestionText, sctLanguage) {
  const parentArrays = suggestionText.split(/\n{2,}/g)	//split by 2 or more occurences of \n
  const arrayOfArrays = parentArrays.map(parentArray => {
    return parentArray
      .split('\n')
      .filter(childString => childString.trim() !== '')
      .map(childString => parseResultSuggestion(childString, sctLanguage))
  })
  return arrayOfArrays
}

export function createResultSuggestions(resultSuggestions, sctLanguage) {
  //Transform json
  const suggestionArr = Object.entries(resultSuggestions).reduce((result, [key, value]) => {
    const arrayOfArrays = createResultSuggestionsFromText(value, sctLanguage)
    const upperCasedKey = gen.capitalize(key)
    result[upperCasedKey] = arrayOfArrays
    return result
  }, {})

  //Add laterality
  const ret = {}
  for (const key in suggestionArr) {
    if (LATERALITY_KEYS.includes(key)) {
      ret[`${key}L`] = suggestionArr[key]
      ret[`${key}R`] = suggestionArr[key]
    } else {
      ret[key] = suggestionArr[key]
    }
  }
  //Return
  return ret
}

